import { shallowEqual, useSelector } from 'react-redux'
import { AsideMenuItem } from '../AsideMenuItem'
import { RootState } from '../../../../../setup'
import { UserModel } from '../../../../../app/modules/auth/models/UserModel'
import { hasPermission, hasRole } from '../../../../../app/utils/permissions'
import { Permission, UserRole } from '../../../../../app/constants/roles'
import { showErrorAlert } from '../../../../../app/helpers/alert'

// PR-I-80: entradas de ACTIVITY estan en preview; abren un modal "Coming Soon"
// con el look estandar de la app hasta que cada feature se libere.
const showComingSoon = () =>
  showErrorAlert({
    title: 'Coming Soon',
    message: 'This feature is on the way.',
  })

export function MenuFinalUser() {
  const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const canManageMember = hasPermission(user, Permission.MANAGE_MEMBER)
  const canMyExperience = hasPermission(user, Permission.MY_EXPERIENCE)
  const canMyExperiences = hasPermission(user, Permission.MY_EXPERIENCES)
  const canHostExperience = hasPermission(user, Permission.HOST_EXPERIENCE)
  const canExperiencesAdmin = hasPermission(user, Permission.EXPERIENCE_ADMIN)
  const canReferMember = hasPermission(user, Permission.REFER_MEMBER)
  const canEditProfile = hasPermission(user, Permission.EDIT_PROFILE_IMAGE)
  const canEditBiography = hasPermission(user, Permission.EDIT_BIOGRAPHY)
  const canMyTeam = hasPermission(user, Permission.TEAM)
  const canMyMembership = hasPermission(user, Permission.MY_MEMBERSHIP)
  const canPayments = hasPermission(user, Permission.PAYMENTS)
  const canFinancialOverview = hasPermission(user, Permission.FINANCIAL_OVERVIEW)

  return (<div className='nb-aside-content'>
        <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <span className='nb-menu-section-title'>MY ACCOUNT</span>
            </div>
            <div className='nb-menu-section-content'>
                {canEditProfile && (<AsideMenuItem to='/biography' title='MY PROFILE' showIcon={true} icon='/media/svg/nobilis/user_nb-gray.svg' />)}
                {canMyTeam && (<AsideMenuItem to={`/user/${user?.id}/my-team`} title='MY TEAM' showIcon={true} icon='/media/svg/nobilis/my-team-gray.svg' disabled={true} />)}
                {canReferMember && (<AsideMenuItem to='/user/refer' title='Refer a Member' showIcon={true} icon='/media/svg/nobilis/ref_member-gray.svg' disabled={true} />)}
                <AsideMenuItem to='/messages' title='Messages' showIcon={true} icon='/media/svg/nobilis/ref_member-gray.svg' disabled={true} />
            </div>
        </div>
        <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <div className='separator_menu'></div>
                <span className='nb-menu-section-title'>MY HOSTING</span>
            </div>
            <div className='nb-menu-section-content'>
                {canMyExperiences && (<AsideMenuItem to='/user/my-experience' title='My Experiences' showIcon={true} icon='/media/svg/nobilis/my-experiences_nb.svg' />)}
                {/* PR-I-80: "Book an Expert" y "My Engagements" removidos del menu por decision
                    de producto: no son parte del proceso actual del member. Las rutas
                    (/book-expert, /engagements y detalles) siguen activas porque otros flujos
                    (busqueda global, detalle de miembro/expertise) navegan hacia ellas. */}
                <AsideMenuItem to='/my-introduction' title='My Introductions' showIcon={true} icon='/media/svg/nobilis/intro_nb.svg' disabled={true} />
                {/* PR-I-85: se restaura MY EXPERTISE para members. Producto priorizo abrirlo a members
                    (revierte parte de PR-I-80). Apunta a /my-expertise (MyExpertisePage: bandeja de
                    Request/Open/Closed) — mismo destino que partners para no bifurcar la vista. */}
                <AsideMenuItem to='/my-expertise' title='My Expertise' showIcon={true} icon='/media/svg/nobilis/my-expertise.svg' disabled={true} />
                <AsideMenuItem to='/my-mastermind-circles' title='My Mastermind circles' showIcon={true} icon='/media/svg/nobilis/my-mastermind-circles-gray.svg' disabled={true} />
            </div>
        </div>

        {/* PR-I-80: seccion ACTIVITY oculta */}
        {/* <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <div className='separator_menu'></div>
                <span className='nb-menu-section-title'>ACTIVITY</span>
            </div>
            <div className='nb-menu-section-content'>
                <AsideMenuItem to='/my-bookings' title='My Bookings' showIcon={true} icon='/media/svg/nobilis/my-booking_nb.svg' disabled={true} />
                <AsideMenuItem to='#' title='Invitations' showIcon={true} icon='/media/svg/nobilis/invitations_nb.svg' disabled={true} onClick={showComingSoon} />
                <AsideMenuItem to='#' title='Wishlist' showIcon={true} icon='/media/svg/nobilis/wishlist_nb.svg' disabled={true} onClick={showComingSoon} />
            </div>
        </div> */}

        <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <span className='nb-menu-section-title'>Membership & Finance</span>
            </div>
            <div className='nb-menu-section-content'>
                {canMyMembership && (<AsideMenuItem to='/financial/membership' title='My membership' showIcon={true} icon='/media/svg/nobilis/membership-gray.svg' disabled={true} />)}
                {canPayments && (<AsideMenuItem to='/user/payment/method' title='Payments' showIcon={true} icon='/media/svg/nobilis/payment-gray.svg' disabled={true} />)}
                {canFinancialOverview && (<AsideMenuItem to='/financial' title='financial overview' showIcon={true} icon='/media/svg/nobilis/financial-overview_nb.svg' disabled={true} />)}
            </div>
        </div>
    </div>
  )
}
